import { ColorSystemDefinition } from "@ancon/wildcat-ui/shared";
import { faArrowRight, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormContext } from "react-hook-form";
import { styled } from "styled-components";

import { FontVariant } from "../../constants/fonts";

const Container = styled.div`
  width: 393px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
  flex: 1;
`;

const ThemeContainer = styled.div`
  width: 100%;
  padding: 10px 20px 8px 20px;
  p {
    margin: 0px;
    margin-bottom: 5px;
  }
`;

const Button = styled.div`
  width: 100%;
  height: 40px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  position: relative;
`;

const CollectSlider = styled.div`
  display: flex;
  flex-direction: row;
`;

const SwipeToggle = styled.div<{ $right?: boolean }>`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background: white;
  position: absolute;
  left: 5px;
  top: 5px;
  ${props => props.$right && "left: auto; right: 5px;"}

  display: flex;
  align-items: center;
  justify-content: center;
`;

export default function ButtonPreviews() {
  const { watch } = useFormContext<ColorSystemDefinition>();
  const values = watch();
  const { secondary, primary } = values;
  const {
    color: PrimaryColor,
    buttons: PrimaryButtons,
    content: PrimaryContent,
  } = primary;
  const {
    color: SecondaryColor,
    buttons: SecondaryButtons,
    content: SecondaryContent,
  } = secondary;

  return (
    <Container>
      <ThemeContainer style={{ backgroundColor: PrimaryColor }}>
        <p style={{ color: PrimaryContent.default }}>Primary Buttons</p>
        <Button
          style={{
            backgroundColor: PrimaryButtons.default.color,
            color: PrimaryButtons.default.content,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Default Primary Button
        </Button>
        <Button
          style={{
            backgroundColor: PrimaryButtons.alt_1.color,
            color: PrimaryButtons.alt_1.content,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Alternative 1 Button
        </Button>
        <Button
          style={{
            backgroundColor: PrimaryButtons.alt_2.color,
            color: PrimaryButtons.alt_2.content,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Alternative 2 Button
        </Button>

        <CollectSlider>
          <Button
            style={{
              fontSize: 11,
              backgroundColor: PrimaryButtons.default.color,
              color: PrimaryButtons.alt_3.content,
              paddingLeft: 5,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            <SwipeToggle>
              <FontAwesomeIcon
                icon={faArrowRight}
                color={PrimaryContent.default}
              />
            </SwipeToggle>
            Mark as collected
          </Button>
          <Button
            style={{
              fontSize: 11,
              backgroundColor: PrimaryButtons.alt_3.color,
              color: PrimaryButtons.alt_3.content,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            <SwipeToggle $right>
              <FontAwesomeIcon icon={faCheck} color={PrimaryContent.success} />
            </SwipeToggle>
            Issued
          </Button>
        </CollectSlider>
      </ThemeContainer>
      <ThemeContainer style={{ backgroundColor: SecondaryColor }}>
        <p
          style={{
            color: SecondaryContent.default,
          }}
        >
          Secondary Buttons
        </p>
        <Button
          style={{
            backgroundColor: SecondaryButtons.default.color,
            color: SecondaryButtons.default.content,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Default Secondary Button
        </Button>
        <Button
          style={{
            backgroundColor: SecondaryButtons.alt_1.color,
            color: SecondaryButtons.alt_1.content,
            fontFamily: FontVariant.PrimaryRegular,
          }}
        >
          Alternative 1 Button
        </Button>
      </ThemeContainer>
    </Container>
  );
}
